import script from "./categoriesAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./categoriesAdd.vue?vue&type=script&setup=true&lang=js"

import "./categoriesAdd.vue?vue&type=style&index=0&id=07d54930&lang=css"
import "./categoriesAdd.vue?vue&type=style&index=1&id=07d54930&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d54930"]])

export default __exports__